import {Component, OnInit, ViewContainerRef} from '@angular/core';
import 'reflect-metadata';
import {SpinnerVisibilityService} from 'ng-http-loader';
import {MesHttpStatusHandlerService, LoadingSpinnerComponent, ensureGlobalSpinnerRemoved, PrimengLocalizationService} from 'common-shared';
import {AuthService} from 'web-shared';
import {filter} from "rxjs/operators";
import {NgSelectConfig} from "@ng-select/ng-select";
import {NgbDropdownConfig} from "@ng-bootstrap/ng-bootstrap";
import {InlineSVGConfig} from "ng-inline-svg-2";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  template: `
    <ng-http-loader [entryComponent]="loadingSpinnerComponent"
      [backgroundColor]="'#ff0000'"
      [debounceDelay]="100"
      [minDuration]="300">
    </ng-http-loader>
    <router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  public loadingSpinnerComponent = LoadingSpinnerComponent;

  constructor(private spinner: SpinnerVisibilityService, private authService: AuthService, private mesHttpStatusHandlerService: MesHttpStatusHandlerService, private ngSelectConfig: NgSelectConfig, private ngbDropdownConfig: NgbDropdownConfig, public viewContainerRef: ViewContainerRef, private inlineSVGConfig: InlineSVGConfig, private primengLocalizationService: PrimengLocalizationService) {
    mesHttpStatusHandlerService.http401.subscribe(value => {
      this.authService.logout();
    });

    ngSelectConfig.appendTo = 'body';
    ngbDropdownConfig.container = 'body';

    inlineSVGConfig.baseUrl = `/assets/img/sprite.svg?v=` + environment.version;
  }

  ngOnInit(): void {
    this.spinner.visibility$.pipe(filter(value => value === false)).subscribe(value => {
      ensureGlobalSpinnerRemoved();
    });

    setTimeout(() => {
      ensureGlobalSpinnerRemoved();
    }, 200);

    this.primengLocalizationService.setLanguage('et');
  }
}
